<template>
  <span v-if="show" class="meter-actual-mark" title="跑码实数">（实）</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  /** 库存行 / 预览行：有 physical_run_verified_at 或 mark_as_meter_actual 即显示 */
  row: { type: Object, default: null },
  /** 直接传布尔/真值 */
  marked: { type: [Boolean, String, Number], default: null }
})

const show = computed(() => {
  if (props.marked != null && props.marked !== '') {
    return props.marked === true || props.marked === 1 || props.marked === '1' || props.marked === 'true'
  }
  const r = props.row
  if (!r) return false
  if (r.mark_as_meter_actual === true || r.mark_as_meter_actual === 1) return true
  return !!r.physical_run_verified_at
})
</script>

<style scoped>
.meter-actual-mark {
  color: #c0392b;
  font-weight: 600;
  font-size: 0.92em;
  margin-left: 1px;
  white-space: nowrap;
}
</style>
